import { Paper, Typography } from '@mui/material';

function NoResultsPaper({ copy = 'No results found' }) {
  return (
    <Paper>
      <Typography variant='body2' sx={{ padding: '16px 16px 24px' }}>
        {copy}
      </Typography>
    </Paper>
  );
}

export default NoResultsPaper;
